// extracted by mini-css-extract-plugin
export const header = "header-module--header--3DHo5";
export const home = "header-module--home--ctcZ8";